export function backendUrl(url: string): string {
    if (process.env.NODE_ENV === 'development') {
        return `http://localhost:8001${url}`;
    }

    return url;
}
